import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV } from "./data";

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("keydown", onKey);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("keydown", onKey);
    };
  }, []);

  const close = () => setOpen(false);

  return (
    <header
      className={`sticky top-0 z-50 bg-paper transition-[border-color] duration-300 border-b ${scrolled || open ? "border-line" : "border-transparent"}`}
      data-testid="site-header"
    >
      <div className="mx-auto flex h-[4.5rem] max-w-[1440px] items-center justify-between px-5 sm:px-8 lg:px-12">
        <a
          href="#top"
          className="inline-flex items-center"
          data-testid="nav-logo"
          onClick={close}
          aria-label="Folkare Bygg – startsida"
        >
          <img
            src="/images/folkare-logo.webp"
            alt=""
            width="320"
            height="129"
            className="h-[38px] w-auto sm:h-[42px]"
          />
        </a>
        <nav aria-label="Huvudmeny" className="hidden lg:block">
          <ul className="flex items-center gap-9">
            {NAV.map((n) => (
              <li key={n.id}>
                <a href={`#${n.id}`} className="link-underline pb-1 text-[0.93rem] font-medium text-ink2 transition-colors hover:text-ink" data-testid={`nav-link-${n.id}`}>
                  {n.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>
        <div className="flex items-center gap-2">
          <a href="#kontakt" className="btn-primary hidden !px-5 !py-3 sm:inline-flex" data-testid="nav-cta-offert">
            Begär offert
          </a>
          <button
            type="button"
            className="-mr-2 inline-flex h-11 w-11 items-center justify-center text-ink lg:hidden"
            aria-expanded={open}
            aria-controls="mobilmeny"
            aria-label={open ? "Stäng meny" : "Öppna meny"}
            onClick={() => setOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
          >
            {open ? <X size={24} strokeWidth={1.5} /> : <Menu size={24} strokeWidth={1.5} />}
          </button>
        </div>
      </div>
      <MobileMenu open={open} close={close} />
    </header>
  );
};

const MobileMenu = ({ open, close }) => (
  <div
    id="mobilmeny"
    hidden={!open}
    className="border-t border-line bg-paper lg:hidden"
    data-testid="mobile-menu"
  >
    <nav aria-label="Mobilmeny" className="px-5 pb-8 pt-2 sm:px-8">
      <ul className="divide-y divide-line">
        {NAV.map((n) => (
          <li key={n.id}>
            <a href={`#${n.id}`} onClick={close} className="block py-4 font-display text-2xl text-ink" data-testid={`mobile-nav-link-${n.id}`}>
              {n.label}
            </a>
          </li>
        ))}
      </ul>
      <a href="#kontakt" onClick={close} className="btn-primary mt-6 w-full" data-testid="mobile-nav-cta-offert">
        Begär offert
      </a>
    </nav>
  </div>
);
